/**
 * GO TO A BOOKMARKED MESSAGE (owner, 2026-10-31: 當使用者點向某一個 List 的時候, 就可以跑到該直接跳到該 Message Block).
 *
 * The list is in a sheet App owns; the messages are in the transcript view. A request is left here and announced; the
 * view of THAT agent takes it — now if it is open, or when it next renders its blocks — loads back to the block when it
 * is above what is loaded, brings it into view and lights it for a moment. It says how it went, for the person to be
 * told when it could not: the bookmark is from an earlier conversation of the agent, or older than the machine serves.
 */
export type JumpResult = 'shown' | 'elsewhere' | 'unreachable'
export type Jump = {
  device: string | null
  session: string
  file: string
  index: number
  onResult?: (r: JumpResult) => void
}

const EVENT = 'avg-bookmark-jump'
let pending: Jump | null = null

export function jumpTo(j: Jump): void {
  pending = j
  window.dispatchEvent(new Event(EVENT))
}

/** The request waiting for this agent's view, taken once. */
export function takeJump(device: string | null, session: string): Jump | null {
  if (!pending || pending.session !== session || (pending.device ?? null) !== (device ?? null)) return null
  const j = pending
  pending = null
  return j
}

export function onJump(fn: () => void): () => void {
  window.addEventListener(EVENT, fn)
  return () => window.removeEventListener(EVENT, fn)
}

/**
 * Which transcript each agent's Clean View is showing, as it last drew — the list marks a bookmark from another file
 * as from an earlier conversation before it is pressed. Written by the view; read when the list opens.
 */
const shown = new Map<string, string>()
const shownKey = (device: string | null, session: string) => `${device ?? ''}\n${session}`

export function noteShownFile(device: string | null, session: string, file: string | null): void {
  if (file) shown.set(shownKey(device, session), file)
}

export function shownFile(device: string | null, session: string): string | null {
  return shown.get(shownKey(device, session)) ?? null
}
